<template>
    <b-modal
        id="notification-devices-modal"
        size="sm"
        centered
        hide-header
        hide-footer
        body-class="p-0"
        ref="devices-notification"
    >
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img src="@/assets/img/devices.svg" />
                <p class="text-light m-0 fs-4 ms-2">Unidades</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg" />
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <div class="find-device input-group mb-3 justify-content-center align-items-center rounded">
                <input type="text" v-model="findPlate" class="searched-device p-2" placeholder="Ejm: D7K-990" />
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-search"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="0.5"
                    stroke="#2c3e50"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                    <path d="M21 21l-6 -6" />
                </svg>
            </div>
            <ul class="list-group">
                <li
                    class="list-group-item"
                    v-for="device in devices.filter((device) => device.name.toUpperCase().includes(findPlate.toUpperCase()))"
                    :key="device.id"
                >
                    <label
                        class="form-check-label d-flex flex-row justify-content-start align-items-center"
                        :for="device.id.toString()"
                    >
                        <input
                            class="form-check-input me-1"
                            type="checkbox"
                            :id="device.id.toString()"
                            v-model="device.selected"
                        />
                        <img :src="require('@/assets/img/devices/' + device.icon + '.png')" />
                        <p class="m-0">{{ device.name }}</p>
                    </label>
                </li>
            </ul>
            <b-button variant="primary" class="mt-3" @click="saveDevices">Guardar</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import IDeviceStore from '@/models/modelStore/IDeviceStore'
import devicesModule from '@/store/modules/devices.module'
import notificationsModule from '@/store/modules/notifications.module'
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component({})
export default class DevicesNotification extends Vue {
    findPlate = ''
    devices: IDeviceStore[] = devicesModule.devices.map((device) => ({
        ...device,
        selected: false
    }))

    close() {
        this.$bvModal.hide('notification-devices-modal')
    }

    show() {
        this.$bvModal.show('notification-devices-modal')
    }

    saveDevices() {
        const selectedDeviceIds = this.devices.filter((device) => device.selected).map((device) => device.id)
        this.$emit('save-devices', selectedDeviceIds)
        this.close()
    }

    get notificationsDevices() {
        return notificationsModule.notificationDataModal.devicesId
    }

    @Watch('notificationsDevices', { immediate: true })
    onChangeNotificationsDevices(devicesId: number[]): void {
        console.log(devicesId)
        this.devices = this.devices.map(device => ({
            ...device,
            selected: devicesId.includes(device.id)
        }))
    }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
@import '@/assets/style/modal-styles.sass'

svg
    stroke-width: 2px
    width: auto
    height: 25px
.form-check-label
    gap: 5px
    cursor: pointer
.list-group
    overflow: auto !important
    max-height: 65vh !important
.list-group-item
    p
        line-height: 20px
    img
        height: 30px

.find-device
    border: 1px solid #dee2e6
.searched-device
    border: none
    text-decoration: none
    &:focus-visible
        border: none
        outline: none
</style>
